import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import { withCampaignFilterValues } from '../../../features/campaigns-management/components/campaigns-filters/components/with-campaign-filter-values/with-campaign-filter-values';
import { CampaignFiltersFormikModel } from '../../../features/campaigns-management/components/campaigns-filters/models/campaign-filters-formik.model';
import { CampaignFilterProps } from '../../../features/campaigns-management/components/campaigns-filters/types/campaign-filter.props';
import {
  filterCampaignsByBrand,
  resetBrandFilter,
} from '../../../features/campaigns-management/store/slices/campaigns.slice';
import { useGetBrands } from '../../../features/firmware-management/hooks/use-get-brands/use-get-brands.hook';
import { mapBrandModelToItemLabelModel } from '../../../features/firmware-management/utils/mapping/mapping.util';
import { castTo } from '../../../features/shared/utils/cast-to';
import { optionEquality } from '../../../features/shared/utils/option-equality/option-equality.util';
import BaseAutocomplete from '../base-autocomplete/base-autocomplete';
import BaseRenderInput from '../base-autocomplete/components/base-render-input/base-render-input';
import { useBaseAutocompleteOnChange } from '../base-autocomplete/hooks/use-base-autocomplete-on-change.hook';

// this component may be used for firmware refactor
const BrandsDropdown: FunctionComponent<CampaignFilterProps> = (
  props: PropsWithChildren<CampaignFilterProps>
): ReactElement => {
  const brands = useGetBrands();

  const {
    setFieldValue,
    campaignSelectFilters: { brandId },
  } = props;

  const onBrandChange = useBaseAutocompleteOnChange<CampaignFiltersFormikModel>(
    'brandId',
    filterCampaignsByBrand,
    setFieldValue,
    [{ fieldName: 'modelIds', valueToReset: [] }],
    resetBrandFilter
  );

  const brandOptions = brands.map(mapBrandModelToItemLabelModel);

  return (
    <FormControl
      data-testid="brands-dropdown-form-control"
      key="brand-vehicle-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="brandId"
        freeSolo={false}
        multiple={false}
        options={brandOptions}
        isOptionEqualToValue={optionEquality}
        value={
          brandId
            ? brandOptions.find(x => x.id === castTo<number>(brandId))
            : null
        }
        onChange={onBrandChange}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="brandId"
            label="Brand"
            name="brandId"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withCampaignFilterValues(BrandsDropdown);
